<div class="modal fade " id='popUp-dist-percorrida' tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
data-backdrop="true" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered" >
    <div class="modal-content " >    

      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Distância percorrida </h5>
        <img data-bs-dismiss="modal" class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg" >
      </div>

      <div class="modal-body" *ngIf=" graphicService.dadosAjudMotorDisPerc">

        <div class="p-3">
          <p class="tit-nome"> {{ graphicService.dadosAjudMotorDisPerc.nome }} </p>
          <div class="d-flex">
            <p class="tit-principal"> {{ graphicService.dadosAjudMotorDisPerc.distanciaTotal }} <span class="tit-segundario">km</span></p>
            <p class="tit-principal ms-3"> {{ graphicService.dadosAjudMotorDisPerc.pesoTotal }} <span class="tit-segundario">kg</span></p>
            <p class="tit-principal ms-3"> {{ graphicService.dadosAjudMotorDisPerc.volTotal }} <span class="tit-segundario">volumes</span></p>
          </div>   
        </div>      
  

        <div *ngFor="let item of graphicService.dadosAjudMotorDisPerc.dadosTrecho; let i=index" >
          <div class="ps-3 pe-3 mb-3" >
            <p class="top-border-radius" [ngStyle]="{ backgroundColor: graphicService.corDistanciaPercorrida }">  Trecho {{i + 1}}</p>
            <div class="d-flex justify-content-around p-2 pe-5 ps-5 bottom-border-radius" [ngStyle]="{ borderColor: graphicService.corDistanciaPercorrida }" >
              <p class="tit-principal"> {{ item.distanciaTrecho }} <span class="tit-segundario">km</span></p>
              <p class="tit-principal"> {{ item.pesoTrecho }}<span class="tit-segundario"> kg </span></p>
              <p class="tit-principal"> {{ item.volTrecho }} <span class="tit-segundario">volumes</span></p>
            </div>
          </div>

          <div class="d-flex flex-row ps-3 pe-3 mb-5">
             <div class="me-3">
              <img src="assets/img/icons/icon-walking.svg" class="p-2 border-color-dinamico btn-hover" (click)="zoomCaminhada(item)" [ngStyle]="{ borderColor: graphicService.corDistanciaPercorrida }" alt="walking"/>            
              <p class="d-flex align-items-center ms-3 border-left-dashed" [ngStyle]="{ borderColor: graphicService.corDistanciaPercorrida }"></p>
              <div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 31.302C15.9507 31.2533 15.8965 31.1995 15.8378 31.1408C15.5131 30.8164 15.0482 30.3424 14.4899 29.7464C13.3728 28.5538 11.8843 26.8756 10.3971 24.9315C8.90877 22.9859 7.42912 20.7838 6.32336 18.5434C5.2149 16.2975 4.5 14.0486 4.5 12C4.5 5.64873 9.64873 0.5 16 0.5C22.3513 0.5 27.5 5.64873 27.5 12C27.5 14.0486 26.7851 16.2975 25.6766 18.5434C24.5709 20.7838 23.0912 22.9859 21.6029 24.9315C20.1157 26.8756 18.6272 28.5538 17.5101 29.7464C16.9518 30.3424 16.4869 30.8164 16.1622 31.1408C16.1035 31.1995 16.0493 31.2533 16 31.302ZM9.5 12C9.5 15.5899 12.4101 18.5 16 18.5C19.5899 18.5 22.5 15.5899 22.5 12C22.5 8.41015 19.5899 5.5 16 5.5C12.4101 5.5 9.5 8.41015 9.5 12Z" fill="#4C5054" stroke="#101316"/>
                  <circle cx="16" cy="12" r="9" fill="white"/>
                </svg>        
                <span class="ordem-entrega"  [ngStyle]="{ 'left': 'item.ordemEntrega'.toString().length === 2 ? '-23px' : '-19px' }" >{{ item.ordemEntrega }} </span>  
              </div>
            </div>          
          <div>
            <p class="mt-1 tit-principal d-flex align-items-baseline ">
             Início da caminhada <span class="tit-segundario ms-2"> {{ item.inicioCaminhada.replace('Z', '') | date: 'HH:mm' }} </span>
             </p>
          <p class="d-flex  tit-principal h-layout align-items-baseline" style="padding-top: 26px;">Distância percorrida <span  class="tit-segundario ms-2">{{ item.distanciaTrecho }} km</span></p>
          <div class="mt-1">
            <p class="tit-principal">Entrega finalizada</p>
            <p class="tit-segundario">{{ item.codCliente }} - {{ item.nomeCliente }}</p>
          </div>
          </div>          

        </div>
      </div>
    
    </div>
  </div>  
</div>    

